import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { apiConfig } from '../../../environments/b2c-config';
import { MsalService } from '@azure/msal-angular';
import { DatabaseCacheService } from '../cache/database-cache.service';

@Injectable({
  providedIn: 'root'
})
export class ContributorAccessService {

  constructor(
    private httpClient: HttpClient,
    private msalService: MsalService,
    private common: DatabaseCacheService
  ) {   }

  createContributorAccess(userId, contributorUserId) {

    let sectionId = this.common.getSelectedSection().sectionId;
    let user = this.msalService.instance.getActiveAccount();
    let loginUserId = JSON.stringify(user.idTokenClaims['sub']);

    var headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    .set('LoginUserId', loginUserId)
      .set('Access-Control-Allow-Origin', '*');

    const contributorAccessPostBody = {
      "userId" : userId,
      "contributorUserId" : contributorUserId,
    }

    const url = `${apiConfig.uri}/licence/${sectionId}/contributorAccesses`;

    return this.httpClient.post(`${apiConfig.uri}/licence/${sectionId}/contributorAccesses`, contributorAccessPostBody, { headers: headers });
  }

  deleteContributorAccess(userId, contributorUserId) {

    let sectionId = this.common.getSelectedSection().sectionId;
    let user = this.msalService.instance.getActiveAccount();
    let loginUserId = JSON.stringify(user.idTokenClaims['sub']);

    var headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    .set('LoginUserId', loginUserId)
      .set('Access-Control-Allow-Origin', '*');

    const url = `${apiConfig.uri}/licence/${sectionId}/contributorAccesses`;

    let params = new HttpParams()
      .set("userId", userId)
      .set("contributorUserId", contributorUserId);

    return this.httpClient.delete(url, { headers: headers, params: params });
  }

}
